import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'

class CamionesEnCircuito {
  static getCamionesEnCircuitoPorCereal () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/camiones_en_circuito_por_cereal`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  }
}

export default CamionesEnCircuito
